export const ENTERPRISE = [
    {
        country: "Argentina",
        keywords: [],
        price: 0.09
    },
    {
        country: "Brazil",
        keywords: [],
        price: 0.091
    },
    {
        country: "Chile",
        keywords: [],
        price: 0.124
    },
    {
        country: "Colombia",
        keywords: [],
        price: 0.028
    },
    {
        country: "Egypt",
        keywords: [],
        price: 0.147
    },
    {
        country: "France",
        keywords: [],
        price: 0.192
    },
    {
        country: "Germany",
        keywords: [],
        price: 0.183
    },
    {
        country: "India",
        keywords: [],
        price: 0.026
    },
    {
        country: "Indonesia",
        keywords: [],
        price: 0.064
    },
    {
        country: "Israel",
        keywords: [],
        price: 0.057
    },
    {
        country: "Italy",
        keywords: [],
        price: 0.099
    },
    {
        country: "Malaysia",
        keywords: [],
        price: 0.12
    },
    {
        country: "Mexico",
        keywords: [],
        price: 0.067
    },
    {
        country: "Netherlands",
        keywords: [],
        price: 0.212
    },
    {
        country: "Nigeria",
        keywords: [],
        price: 0.077
    },
    {
        country: "Pakistan",
        keywords: [],
        price: 0.072
    },
    {
        country: "Peru",
        keywords: [],
        price: 0.1
    },
    {
        country: "Russia",
        keywords: [],
        price: 0.113
    },
    {
        country: "Saudi Arabia",
        keywords: [],
        price: 0.069
    },
    {
        country: "South Africa",
        keywords: [],
        price: 0.06
    },
    {
        country: "Spain",
        keywords: [],
        price: 0.089
    },
    {
        country: "Turkey",
        keywords: [],
        price: 0.026
    },
    {
        country: "United Arab Emirates",
        keywords: [],
        price: 0.06
    },
    {
        country: "United Kingdom",
        keywords: [
            "england",
            "northern ireland",
            "scotland",
            "wales"
        ],
        price: 0.079
    },
    {
        country: "North America",
        keywords: [
            "united states, usa, canada"
        ],
        price: 0.044
    },
    {
        country: "Rest of Africa",
        keywords: [],
        price: 0.041
    },
    {
        country: "Rest of Asia Pacific",
        keywords: [],
        price: 0.104
    },
    {
        country: "Rest of Central & Eastern Europe",
        keywords: [],
        price: 0.12
    },
    {
        country: "Rest of Latin America",
        keywords: [],
        price: 0.105
    },
    {
        country: "Rest of Middle East",
        keywords: [],
        price: 0.055
    },
    {
        country: "Rest of Western Europe",
        keywords: [],
        price: 0.087
    },
    {
        country: "Other",
        keywords: [],
        price: 0.088
    }
];